import { UserCircleIcon } from "@heroicons/react/24/outline";
import SeatMigration from "./SeatMigration";
import StaffUser from "./StaffUser";
import TripOnBoard from "./TripOnBoard";
import CounterPanel from "./CounterPanel";
import Coach from "./Coach";

const CounterAdminRoutes = [
    {
        path: "counter-admin",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Counter Admin",
        icon: UserCircleIcon,
        children: [
            ...CounterPanel,
            ...StaffUser,
            ...TripOnBoard,
            ...SeatMigration,
            ...Coach,
        ],
    },
];

export default CounterAdminRoutes;
